const TIME_VALUE_PATTERN = /^(\d{1,2}):(\d{2})/;

export const normalizeTimeInputValue = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }

  const match = trimmed.match(TIME_VALUE_PATTERN);
  if (!match) {
    return '';
  }

  const hours = Math.min(23, Math.max(0, Number(match[1])));
  const minutes = Math.min(59, Math.max(0, Number(match[2])));

  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
    return '';
  }

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const parseTimeInputValue = (value: string): { hours: string; minutes: string } | null => {
  const normalized = normalizeTimeInputValue(value);
  if (!normalized) {
    return null;
  }

  const [hours, minutes] = normalized.split(':');
  return { hours, minutes };
};

export const composeTimeInputValue = (hours: string, minutes: string): string => {
  if (!hours || !minutes) {
    return '';
  }

  return normalizeTimeInputValue(`${hours}:${minutes}`);
};

export const TIME_INPUT_HOURS = Array.from({ length: 24 }, (_, index) => String(index).padStart(2, '0'));

export const TIME_INPUT_MINUTES = Array.from({ length: 60 }, (_, index) => String(index).padStart(2, '0'));
